import { render } from "./Home-Component.vue?vue&type=template&id=44a7c319"
import script from "./Home-Component.vue?vue&type=script&lang=js"
export * from "./Home-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__